export default {
  default: {
    '3XL': 'typography-default-3XL',
    '2XL': 'typography-default-2XL',
    XL: 'typography-default-XL',
    large: 'typography-default-large',
    MExtra: 'typography-default-MExtra',
    MSemi: 'typography-default-MSemi',
    SExtra: 'typography-default-SExtra',
    SSemi: 'typography-default-SSemi',
    XSExtra: 'typography-default-XSExtra',
    XSSemi: 'typography-default-XSSemi',
    XSMedium: 'typography-default-XSMedium',
    XXS: 'typography-default-XXS',
    bodyXL: 'typography-default-bodyXL',
    bodyL: 'typography-default-bodyL',
    body: 'typography-default-body',
    bodyWide: 'typography-default-bodyWide',
    bodyTight: 'typography-default-bodyTight',
    body12: 'typography-default-body12',
    bodySmall: 'typography-default-bodySmall',
    SpecialXSExtra: 'typography-default-SpecialXSExtra',
    SpecialXSSemi: 'typography-default-SpecialXSSemi',
    SpecialXSMedium: 'typography-default-SpecialXSMedium',
    Breadcrumb: 'typography-default-Breadcrumb'
  },
  type: {
    '3XL': 'typography-type-3XL',
    '2XL': 'typography-type-2XL',
    XL: 'typography-type-XL',
    large: 'typography-type-large',
    MExtra: 'typography-type-MExtra',
    MSemi: 'typography-type-MSemi',
    SExtra: 'typography-type-SExtra',
    SSemi: 'typography-type-SSemi',
    XSExtra: 'typography-type-XSExtra',
    XSSemi: 'typography-type-XSSemi',
    XSMedium: 'typography-type-XSMedium',
    XXS: 'typography-type-XXS',
    bodyXL: 'typography-type-bodyXL',
    bodyL: 'typography-type-bodyL',
    body: 'typography-type-body',
    bodyWide: 'typography-type-bodyWide',
    bodyTight: 'typography-type-bodyTight',
    body12: 'typography-type-body12',
    bodySmall: 'typography-type-bodySmall',
    SpecialXSExtra: 'typography-type-SpecialXSExtra',
    SpecialXSSemi: 'typography-type-SpecialXSSemi',
    SpecialXSMedium: 'typography-type-SpecialXSMedium',
    Breadcrumb: 'typography-type-Breadcrumb'
  },
  lineheighted: {
    '3XL': 'typography-lineheighted-3XL',
    '2XL': 'typography-lineheighted-2XL',
    XL: 'typography-lineheighted-XL',
    large: 'typography-lineheighted-large',
    MExtra: 'typography-lineheighted-MExtra',
    MSemi: 'typography-lineheighted-MSemi',
    SExtra: 'typography-lineheighted-SExtra',
    SSemi: 'typography-lineheighted-SSemi',
    XSExtra: 'typography-lineheighted-XSExtra',
    XSSemi: 'typography-lineheighted-XSSemi',
    XSMedium: 'typography-lineheighted-XSMedium',
    XXS: 'typography-lineheighted-XXS',
    bodyXL: 'typography-lineheighted-bodyXL',
    bodyL: 'typography-lineheighted-bodyL',
    body: 'typography-lineheighted-body',
    bodyWide: 'typography-lineheighted-bodyWide',
    bodyTight: 'typography-lineheighted-bodyTight',
    body12: 'typography-lineheighted-body12',
    bodySmall: 'typography-lineheighted-bodySmall',
    SpecialXSExtra: 'typography-lineheighted-SpecialXSExtra',
    SpecialXSSemi: 'typography-lineheighted-SpecialXSSemi',
    SpecialXSMedium: 'typography-lineheighted-SpecialXSMedium',
    Breadcrumb: 'typography-lineheighted-Breadcrumb'
  },
  colored: {
    '3XL': 'typography-colored-3XL',
    '2XL': 'typography-colored-2XL',
    XL: 'typography-colored-XL',
    large: 'typography-colored-large',
    MExtra: 'typography-colored-MExtra',
    MSemi: 'typography-colored-MSemi',
    SExtra: 'typography-colored-SExtra',
    SSemi: 'typography-colored-SSemi',
    XSExtra: 'typography-colored-XSExtra',
    XSSemi: 'typography-colored-XSSemi',
    XSMedium: 'typography-colored-XSMedium',
    XXS: 'typography-colored-XXS',
    bodyXL: 'typography-colored-bodyXL',
    bodyL: 'typography-colored-bodyL',
    body: 'typography-colored-body',
    bodyWide: 'typography-colored-bodyWide',
    bodyTight: 'typography-colored-bodyTight',
    body12: 'typography-colored-body12',
    bodySmall: 'typography-colored-bodySmall',
    SpecialXSExtra: 'typography-colored-SpecialXSExtra',
    SpecialXSSemi: 'typography-colored-SpecialXSSemi',
    SpecialXSMedium: 'typography-colored-SpecialXSMedium',
    Breadcrumb: 'typography-colored-Breadcrumb'
  }
};
//# sourceMappingURL=classes.js.map